import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  flexRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttonBorder: {
    borderColor: '#CCCCCC',
  },
  confirmButton: {
    marginLeft: '16px',
    backgroundColor: '#E8192C',
    color: '#FFFFFF',
  },
  tabContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '24px',
  },
}));
